import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { discountOptions } from "../../../utils/discountOptions";

export const DealerColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  hideColmn,
) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  return [
    // {
    //   title: "No",
    //   dataIndex: "DealerNo",
    //   key: "DealerNo",
    //   sorter: (a, b) => a?.DealerNo - b?.DealerNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="DealerNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "DealerNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },

    {
      title: "Name",
      dataIndex: "DealerName",
      key: "DealerName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Description",
      dataIndex: "DealerDesc",
      key: "DealerDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    ...([1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)
      ? [
          {
            title: "Guest",
            dataIndex: "Guest",
            key: "Guest",
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey="Guest"
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams((prev) => ({
                  ...modParams,
                  sort_by: "Guest",
                  order: modParams.order === "desc" ? "asc" : "desc",
                })),
            }),
          },
        ]
      : []),
    ...(loggedInUser?.role_value === 1
      ? [
          {
            title: "Max Account",
            dataIndex: "MaxAccount",
            key: "MaxAccount",
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey="MaxAccount"
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams((prev) => ({
                  ...modParams,
                  sort_by: "MaxAccount",
                  order: modParams.order === "desc" ? "asc" : "desc",
                })),
            }),
          },
        ]
      : []),

    // ...([1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)
    //   ? [
    //       {
    //         title: "Guest",
    //         dataIndex: "Guest",
    //         key: "Guest",
    //         sorter: (a, b) => () => {},
    //         sortIcon: () => (
    //           <SortIcon
    //             sortOrder={modParams.order}
    //             columnKey="Guest"
    //             sortBy={modParams.sort_by}
    //           />
    //         ),
    //         onHeaderCell: () => ({
    //           onClick: () =>
    //             setParams((prev) => ({
    //               ...modParams,
    //               sort_by: "Guest",
    //               order: modParams.order === "desc" ? "asc" : "desc",
    //             })),
    //         }),
    //       },
    //     ]
    //   : []),
    ...([1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)
      ? [
          {
            title: "Discount",
            dataIndex: "Discount",
            key: "Discount",
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey="Discount"
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams((prev) => ({
                  ...modParams,
                  sort_by: "Discount",
                  order: modParams.order === "desc" ? "asc" : "desc",
                })),
            }),
            render: (text) => {
              const matchedValue = discountOptions.find(
                (item) => item.value === text,
              )?.label;
              return <>{matchedValue}</>;
            },
          },
        ]
      : []),
    ...([1, 2, 3, 4, 5, 6].includes(loggedInUser?.role_value)
      ? [
          {
            title: "License",
            dataIndex: "License",
            key: "License",
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey="LicenseNo"
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams((prev) => ({
                  ...modParams,
                  sort_by: "LicenseNo",
                  order: modParams.order === "desc" ? "asc" : "desc",
                })),
            }),
          },
        ]
      : []),
    {
      title: "OEM",
      dataIndex: "Oem",
      hidden: hideColmn,
      key: "Oem",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Billing Cycle",
    //   dataIndex: "BillingCycle",
    //   key: "BillingCycle",
    //   sorter: (a, b) => a?.BillingCycle?.length - b?.BillingCycle?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="BillingCycle"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "BillingCycle",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Auto Billing",
    //   dataIndex: "AutoBilling",
    //   key: "AutoBilling",
    //   sorter: (a, b) => a?.AutoBilling?.length - b?.AutoBilling?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="AutoBilling"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "AutoBilling",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                  <Link
                    to={`/dealer/edit/${record?.DealerNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.DealerNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
